import React, { useEffect, useState } from "react";
import { Popup, Position } from "devextreme-react/popup";
import FileUploader from "devextreme-react/file-uploader";
import TextBox from "devextreme-react/text-box";
import TextArea from "devextreme-react/text-area";
import { Validator, RequiredRule } from "devextreme-react/validator";
import { confirm } from "devextreme/ui/dialog";
import { Toast } from "devextreme-react/toast";
import Button from "devextreme-react/button";
import { getTypeOfFile, onDownloadFile } from "../../../common/utils";
import AsyncCallHandler from "../../../common/AsyncCallHandler";
import { alert } from "devextreme/ui/dialog";
import {
  ALLOWED_FILE_EXTENSIONS,
  ALLOWED_MIME_TYPES,
} from "../../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../../utils/fileValidator";

export default ({
  hideInfo,
  show,
  updateAlertInfo,
  tpl,
  activeAlert,
  popupTitle,
  getCall = () => {},
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "info",
    message: "",
  });

  useEffect(() => {
    setPopup(activeAlert);
  }, [activeAlert]);

  const deleteFile = () => {
    confirm("Are you sure you want to delete?", "Confirm changes").then(
      (res) => {
        if (res) {
          let url = `digitaltier/deleteAttachedBlobFile?fileName=${
            encodeURIComponent(activeAlert?.imageName)}&folderName=${"Sites"}`,
            method = "delete";
          AsyncCallHandler(url, method).then((res) => {
            if (res) {
              activeAlert["imageName"] = "";
              getCall();
            }
          });
        }
      }
    );
  };

  const onFileSelect = (e) => setSelectedFiles(e.value);

  const setPopup = (activeAlert) => {
    setTitle(activeAlert ? activeAlert.messageTitle : "");
    setDesc(activeAlert ? activeAlert.messageDescription : "");
  };
  function onHiding() {
    setTitle("");
    setDesc("");
    setSelectedFiles([]);
    hideInfo();
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  function onShowing() {
    setPopup(activeAlert);
  }

  const closeButton = () => {
    if (title !== "") {
      const validateUploadFiles = checkUploadFilesValid(
        selectedFiles,
        ALLOWED_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );

        alert(alertMsg.join("<br/>"), "Alert");
        return false;
      }

      let formData = new FormData();
      formData.append("filedata", selectedFiles[0] ? selectedFiles[0] : null);
      formData.append("id", activeAlert ? activeAlert.id : 0);
      formData.append("message_title", title);
      formData.append("message_description", desc ? desc : "");
      formData.append("imagePath", activeAlert ? activeAlert.imagePath : "");
      formData.append("imageName", activeAlert ? activeAlert.imageName : "");

      setTitle("");
      setDesc("");
      setSelectedFiles([]);

      updateAlertInfo(formData);

      if (!activeAlert) {
        if (popupTitle === "Communications/Recognition") {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Post Added Successfully!!",
          });
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Alert Added Successfully!!",
          });
        }
      } else {
        if (popupTitle === "Communications/Recognition") {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Post Edited Successfully!!",
          });
        } else {
          setToastConfig({
            ...toastConfig,
            isVisible: true,
            type: "success",
            message: "Alert Edited Successfully!!",
          });
        }
      }
    } else {
      alert("Title is required !");
      return false;
    }
  };

  return (
    //<div id="container">
    <>
      <Popup
        visible={show}
        onHiding={onHiding}
        onShowing={onShowing}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        title={popupTitle}
        //container=".dx-viewport"
        width={500}
        height={600}
      >
        <>
          <div className="dx-fieldset">
            <div className="dx-field">
              <div className="dx-field-label">Title*</div>
              <TextBox
                name="FirstName"
                value={title}
                onValueChanged={(e) => setTitle(e.value)}
                className="dx-field-value"
              >
                <Validator>
                  <RequiredRule message="Title is required" />
                </Validator>
              </TextBox>
            </div>
            <br />
            <div className="dx-field">
              <div className="dx-field-label">Description</div>
              <TextArea
                name="Description"
                className="dx-field-value"
                height={80}
                value={desc}
                onValueChanged={(e) => setDesc(e.value)}
              />
            </div>
            <br />
            <div
              className="dx-field"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div className="dx-field-label">Attachment</div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                {activeAlert?.imageName && (
                  <div>
                    <a
                      style={{ cursor: "pointer" }}
                      className="clickable-hover"
                      onClick={() => {
                        getTypeOfFile(
                          {
                            imageName: activeAlert.imageName,
                            fileExtension: activeAlert?.imageName.split(".")[1],
                          },
                          "Sites"
                        );
                      }}
                    >
                      {" "}
                      {activeAlert?.imageName}
                    </a>
                    &nbsp; &nbsp;&nbsp;
                    {(activeAlert.imageName != "DELETED" || "") && (
                      <>
                        {" "}
                        <i
                          title="Delete"
                          className="fas fa-trash pointer"
                          onClick={() => deleteFile()}
                        ></i>
                        &nbsp; &nbsp;&nbsp;
                        <i
                          title="Download"
                          className="fa fa-download pointer"
                          onClick={() =>
                            onDownloadFile(activeAlert?.imageName, "Sites")
                          }
                        ></i>
                      </>
                    )}
                  </div>
                )}
                {(!activeAlert?.imageName ||
                  activeAlert?.imageName == "DELETED" ||
                  "") && (
                    <FileUploader
                      className="dx-field-value"
                      selectButtonText="Choose file"
                      labelText="Max. File Size 4 MB"
                      accept="*"
                      uploadMode="useForm"
                      onValueChanged={onFileSelect}
                      value={selectedFiles}
                      allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
                    />
                  )}
              </div>
            </div>
            <br />
            <div className="dx-field">
              <Button
                className="dx-field-value dx-button button-popup-save"
                text="Save"
                onClick={closeButton}
              />
            </div>
          </div>
        </>

        <Position at="center" my="center" />
      </Popup>
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />
    </>
    // </div>
  );
};
